import { StyleSheet } from "react-native";
import { mainScreen } from "../Styles/mainScreen";

export default StyleSheet.create({
  ...mainScreen,
  iconEdit: {
    position: "absolute",
    top: 5,
    right: 0,
  },
  redesContainer: {
    padding: 10,
    borderRadius: 8,
    backgroundColor: "#000A",
    marginTop: 20,
    flexDirection: "row",
    alignItems: "center",
    overflow: "hidden",
  },
  marcador: {
    fontFamily: "Montserrat-Medium",
    fontSize: 26,
    marginEnd: 4,
  },
  textRedes: {
    fontFamily: "Montserrat-Medium",
    fontSize: 16,
    color: "#F1F1F1",
  },
  fade: {
    position: "absolute",
    backgroundColor: "#CCCC",
    width: "150%",
    height: "150%",
    borderRadius: 8,
    zIndex: 10,
    overflow: "hidden",
    opacity: 0.6,
  },
});
